// extracted by mini-css-extract-plugin
export default {"page":"ChangePasswordForm_page__hKPAF","card":"ChangePasswordForm_card__OqrKb","title":"ChangePasswordForm_title__OOmqb","subtitle":"ChangePasswordForm_subtitle__T3i5F"};